// extracted by mini-css-extract-plugin
export default {"link":"_55bfd018","phone":"_1d1fa6e4","contrastLink":"_6ecc03a"};